import $ from 'jquery';
import variables from '../variables';

// current section title selector (in sidebar)
const sectionTitle = $('#section-title');

// current section sidebar nav holder
const sidebarSectionNav = $('#sidebar-section-nav');

const mainNavigation = {

  // # initially set toggled state to false, the menu should not be toggled initially
  toggled: false,
  // # main navigation list container, this is the list that will be toggled
  container: $('.main-navigation'),
  // # toggle button
  toggleButton: $('.main-navigation-toggler > a'),

  addCarrot() {
    $('ul > li', this.container).each((_index, el) => {
      if ($(el).children('ul').length) {
        $(el).prepend('<div class="sub-navigation-caret"><a href="#"><i class="fa fa-caret-down"></i></a></div>');
        // ###
        // # append dropdown content to the sidebar sub navigation container,
        // # the main menu will have the navigation in the correct order already
        // ###
        const thisSectionTitle = $(el).children('a').text();
        if (thisSectionTitle === sectionTitle.text() || thisSectionTitle === `${sectionTitle.text()}s`) {
          sidebarSectionNav.html($(el).children('ul').html());
        }
        // ###
        // # add "Hovering" class to the parent of the current hovering caret and sub-menu
        // ###
        $('.sub-navigation-caret, .sub-menu').hover(
          (_ev) => $(el).closest('.menu-item').addClass('hovering-on-child'),
          (_ev) => $(el).closest('.menu-item').removeClass('hovering-on-child'),
        );
      }
    });
  },

  // Toggle sub navigation on click of the
  // caret toggle button
  //
  toggleSubMenuWithCaret() {
    $('.sub-navigation-caret').click((e) => {
      const thisCaret = $(e.currentTarget);
      const sub = $(e.currentTarget).siblings('ul');
      if (sub.is(':visible')) {
        sub.slideUp(100);
        this.toggleButtonDown(thisCaret);
      } else {
        sub.slideDown(100);
        this.toggleButtonUp(thisCaret);
      }
    });
  },

  toggleSubNavWithLink() {
    $('.sub-navigation-caret').siblings('a').click((e) => {
      const thisLink = $(e.currentTarget);
      const sub = $(e.currentTarget).siblings('ul');
      if (sub.is(':visible')) {
        sub.slideUp(100);
        this.toggleButtonDown(thisLink.siblings('.sub-navigation-caret'));
      } else {
        sub.slideDown(100);
        this.toggleButtonUp(thisLink.siblings('.sub-navigation-caret'));
      }
    });
  },

  toggleButtonDown(el) { return el.html('<a href="#"><i class="fa fa-caret-down"></i></a>'); },

  toggleButtonUp(el) { return el.html('<a href="#"><i class="fa fa-caret-up"></i></a>'); },

  //
  // Initialize the menu
  //
  init() {
    this.toggler();
    this.addCarrot();
    this.toggleSubMenuWithCaret();
    this.toggleSubNavWithLink();
  },

  // ###* Toggle navigation on click of the
  // # main navigation toggle button
  // # reset to default when clicked again
  // ###
  toggler() {
    mainNavigation.toggleButton.click((_e) => {
      // ###* toggle clicked check each time ###
      // eslint-disable-next-line no-bitwise
      this.toggled ^= true;
      if (this.container.is(':visible')) {
        this.container.slideUp(100);
      } else {
        this.container.slideDown(100);
      }
    });
  },
};

// ###* make sure we turn back on the
// # nav box if the window size gets
// # bigger than the tablet size
// ###

$(window).resize((_e) => {
  const windowWidth = $(window).width();
  if (windowWidth <= variables.tabletMax && mainNavigation.toggled !== false) {
    mainNavigation.container.show();
  } else if (windowWidth > variables.tabletMax) {
    mainNavigation.container.show();
    mainNavigation.toggled = false;
    $('ul li > ul', mainNavigation.container).attr({ style: '' });
  } else {
    mainNavigation.container.hide();
  }
});

export default mainNavigation;
